import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy, SimpleChanges } from '@angular/core';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import {  TaxaJurosMediaMaximaAgente } from 'src/app/model/taxa-juros-media-maxima-agente.model';
import { TaxaJurosEquivalenteService } from 'src/app/shared/services/taxa-juros-equivalente.service';
import { JanelaApuracaoTaxaMediaMaximaAgente } from 'src/app/model/janela-apuracao-taxa-media-maxima-agente';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-taxa-juros-media-agente-listagem',
    templateUrl: './taxa-juros-media-agente-listagem.component.html',
    styleUrls: ['./taxa-juros-media-agente-listagem.component.scss'],
    standalone: false
})
export class TaxaJurosMediaAgenteListagemComponent implements OnInit {

  @Input() agenteFinanceiro: AgenteFinanceiro;
  @Input() permiteEdicao: boolean = false;
  @Input() compararComTaxaMaxima: boolean= false;
  @Input() ideTranche: number;
  @Input() todasJanelas: JanelaApuracaoTaxaMediaMaximaAgente[];

  @Input() taxas: TaxaJurosMediaMaximaAgente[];

  constructor(private service: TaxaJurosEquivalenteService,
    private loadingService: BnLoadingService,
    private datePipe: DatePipe,) {
  }

  ngOnInit() {
  }

  public encontrarIdJanelaTaxaMediaMaxima(ideJanelaApuracao: number): string{
    const janela = this.todasJanelas.find(janela => janela.id == ideJanelaApuracao);
    return janela.id.toString() + " ("+ this.datePipe.transform(janela.dataInicioJanela,'dd/MM/yyyy') + ")";
  }

  verificarTaxaMediaMaiorTaxaMaxima(taxa: TaxaJurosMediaMaximaAgente): boolean{
    if(this.compararComTaxaMaxima && (parseFloat(taxa.fator.toString()) < 100.00)){
      return true;
    }
    return false;
  }
}